import moment from 'moment';

export const eventMixin = {
  props: {
    event: {},
  },
  methods: {
    getCompanyNameNormalized: function(companyName) {
      return companyName.replace(/\s/g, '').toLowerCase();
    },
    getSpeakerNameNormalized: function(speakerName) {
      return speakerName.replace(/\s/g, '').toLowerCase();
    },
    doAllEventUsersHaveTheSameCompany: function() {
      let companyIds = this.event.eventUsers
        .filter(eu => eu.user !== null && eu.user.company !== null)
        .map(eu => eu.user.company.id);
      let uniqueCompanyIds = [...new Set(companyIds)];
      if (uniqueCompanyIds.length > 1) return false;

      return true;
    },
    getSortedEventUsers: function(event) {
      return event.eventUsers
        .filter(eu => eu.user !== null && eu.user.hasImage)
        .sort(function(firstEventUser, secondEventUser) {
          if (firstEventUser.userEventRole < secondEventUser.userEventRole) return -1;
          else if (firstEventUser.userEventRole > secondEventUser.userEventRole) return 1;
          if (firstEventUser.user.lastName < secondEventUser.user.lastName) return -1;

          return 1;
        });
    },
    isInViewport: function(ref, offset = 0) {
      const rect = ref.getBoundingClientRect();

      return rect.top - offset <= (window.innerHeight || document.documentElement.clientHeight);
    },
    handleFlyInIntersection: function() {
      const flyIn = this.$refs.flyIn;

      if (!flyIn) {
        return;
      }

      if (getComputedStyle(flyIn).visibility === 'hidden') {
        flyIn.classList.remove('fly-in');

        return;
      }

      if (this.isInViewport(flyIn, 200)) {
        flyIn.classList.add('fly-in');
      }
    },
    addIntersectionObserverListeners: function() {
      document.addEventListener('scroll', this.handleFlyInIntersection);
    },
    removeIntersectionObserverListeners: function() {
      document.removeEventListener('scroll', this.handleFlyInIntersection);

      document.removeEventListener('schedule-change', this.handleFlyInIntersection);
    },
    hasEventEnded: function() {
      if (!this.event) {
        return false;
      }
      return moment().diff(this.event.ends) > 0;
    },
    hasEventStarted: function() {
      if (!this.event) {
        return false;
      }
      return moment().diff(this.event.starts) > 0;
    },
  },
  data() {
    return {
      hasEnded: this.hasEventEnded(),
      hasStarted: this.hasEventStarted(),
    };
  },
  mounted() {
    let dropdownArrow;

    if (this.$el.querySelector) {
      dropdownArrow = this.$el.querySelector('.button__expand');
    }

    const description = this.$refs.description;
    const container = this.$refs.flyIn;
    if (container && description) {
      container.addEventListener('click', function() {
        dropdownArrow.classList.toggle('active');
        description.classList.toggle('active');
      });
    }
    if (container) {
      this.addIntersectionObserverListeners();
    }
    this.handleFlyInIntersection();
  },
  destroyed() {
    this.removeIntersectionObserverListeners();
  },
};

export const deviceHandling = {
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile: function() {
      return this.windowWidth <= 768;
    },
  },
  mounted() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.windowWidth = window.innerWidth;
      }, 250);
    });
  },
};
